<script setup>
import { onMounted, defineProps } from "vue";

const props = defineProps({
  imgUrl: {
    type: String,
    default: "@/assets/image/home/Face.png",
  },
  userName: {
    type: String,
    default: "名字",
  },
  sub: {
    type: String,
    default: "职位",
  },
  text: {
    type: String,
    default: "内容",
  },
});

onMounted(() => {});
</script>

<template>
  <div class="user_card">
    <div>
      <div class="user_card_top">
        <span style="display: flex; align-items: center">
          <img class="user_card_img" :src="imgUrl" alt="" />
          <span class="user_card_title">{{ userName }}</span>
        </span>
        <span class="user_card_sub">{{ sub }}</span>
      </div>
      <div class="user_card_content">
        <span class="user_card_r_subtitle">{{ text }}</span>
      </div>
    </div>
    <div class="user_card_bottom">
      <img class="user_card_star" src="@/assets/image/home/Star.png" alt="" />
      <img class="user_card_star" src="@/assets/image/home/Star.png" alt="" />
      <img class="user_card_star" src="@/assets/image/home/Star.png" alt="" />
      <img class="user_card_star" src="@/assets/image/home/Star.png" alt="" />
      <img class="user_card_star" src="@/assets/image/home/Star.png" alt="" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.user_card {
  cursor: default;
  width: 478px;
  min-height: 314px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px #a3a3a340;
  .user_card_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .user_card_img {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .user_card_title {
      font-size: 24px;
      color: #333;
      font-weight: 600;
    }
    .user_card_sub {
      font-size: 24px;
      color: #999999;
    }
  }
  .user_card_content {
    padding: 20px 0;
    .user_card_r_subtitle {
      font-size: 22px;
      color: #999999;
      font-weight: 400;
    }
  }
  .user_card_bottom {
    display: flex;
    .user_card_star {
      width: 29px;
      height: 29px;
      margin-right: 10px;
    }
  }
}
</style>
